import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pick, omit, map } from 'lodash';
import { Button, Modal, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import Toggle from 'react-bootstrap-toggle';
import Joi from 'joi';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import Fa from 'react-fontawesome';
import { viewTeam, createTeam, updateTeam, fetchManagers } from '../../TeamActions';
import { getUserCurrentOrganization, getCanSetupOrganization } from '../../../Auth/AuthReducer';
import UserSelector from '../../../../components/multi-user-selector';
import ProgressBar from '../../../../components/progress-bar';

class TeamModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      users: [], // for autocompete
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.onToggleDefault = this.onToggleDefault.bind(this);
    this.onToggleGlobal = this.onToggleGlobal.bind(this);
    this.handleSelectUsers = this.handleSelectUsers.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show && nextProps.show) {
      // const currentId = this.props.team ? this.props.team._id : null;
      const newId = nextProps.team ? nextProps.team._id : null;
      this.setState({ loading: true }, () => {
        if (newId) {
          this.props.dispatch(viewTeam(newId))
            .then(
              ({ team, users }) => {
                this.props.initialize(team);
                this.setState({ loading: false, users });
              },
              (e) => {

              },
            );
        } else {
          this.props.initialize(nextProps.team);
          this.setState({ loading: false, users: [] });
        }
      });
    }
  }

  onToggleDefault() {
    const { isDefault } = this.props;
    this.props.change('is_default', !isDefault);
  }

  onToggleGlobal() {
    const { isGlobal } = this.props;
    this.props.change('is_global', !isGlobal);
  }

  handleSelectUsers(users) {
    this.props.change('shared_with', map(users, '_id'));
  }

  close() {
    if (!this.props.submitting) {
      this.props.onClose();
    }
  }

  handleSubmit(data) {
    const { canSetupGlobalTeam } = this.props;
    const attrs = ['name', 'description', 'is_default', 'annual_sales_goal'];
    if (canSetupGlobalTeam) {
      attrs.push('is_global');
      attrs.push('shared_with');
    }
    const params = pick(data, attrs);
    const isNew = data._id === null || data._id === undefined;
    return this.props.dispatch(isNew ? createTeam(params) : updateTeam(data._id, params))
      .then(
        ({ team }) => {
          this.props.onClose();
          this.props.onSuccess(team, isNew);
        },
        (errors) => {
          let e = errors;
          if (errors.data) {
            e = errors.data;
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, componentClass, meta: { touched, error },
  }) {
    const { submitting, organization } = this.props;
    const validationState = touched && error ? 'error' : null;
    const prefix = organization.currency_symbol;

    return (
      <FormGroup validationState={validationState} className="">
        <ControlLabel>{label}</ControlLabel>
        {componentClass !== 'number' && <FormControl {...input} componentClass={componentClass} placeholder={label} type={type} disabled={submitting} />}
        {componentClass === 'number' &&
          <NumberFormat
            className="form-control"
            thousandSeparator
            prefix={prefix}
            {...omit(input, ['onChange', 'onBlur'])}
            disabled={submitting}
            decimalScale={2}
            placeholder={label}
            allowNegative={false}
            onValueChange={(v) => {
              this.props.change(input.name, v.floatValue || null);
            }}
          />
        }
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const {
      show, team, submitting, invalid,
      handleSubmit, isDefault, isGlobal,
      canSetupGlobalTeam,
    } = this.props;

    const { loading, users } = this.state;

    const isNew = !team || !team._id;
    let btn = isNew ? 'Save' : 'Update';
    if (submitting) {
      btn = isNew ? 'Saving' : 'Updating';
    }
    const icon = submitting ? 'spinner' : 'check';

    return (
      <div>
        <Modal
          show={show}
          onHide={this.close}
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isNew && <span>Create a New Team</span>}
              {!isNew && <span>Update Team Info</span>}
            </Modal.Title>
          </Modal.Header>
          {loading &&
            <Modal.Body>
              <ProgressBar />
            </Modal.Body>
          }
          {!loading &&
            <form onSubmit={handleSubmit(this.handleSubmit)}>
              <Modal.Body>
                <div>
                  <Field
                    name="name"
                    type="text"
                    component={this.renderField}
                    label="Team Name"
                  />

                  <Field
                    name="description"
                    componentClass="textarea"
                    component={this.renderField}
                    label="Description"
                  />

                  <Field
                    name="annual_sales_goal"
                    componentClass="number"
                    component={this.renderField}
                    label="Annual Sales Goal"
                  />

                  <FormGroup>
                    <ControlLabel>Is Default Team:</ControlLabel>
                    <div>
                      <Toggle
                        onClick={this.onToggleDefault}
                        on={<span>YES</span>}
                        off={<span>No</span>}
                        size="xs"
                        onstyle="success"
                        offstyle="default"
                        active={isDefault}
                      />
                    </div>
                  </FormGroup>

                  {canSetupGlobalTeam &&
                    <FormGroup>
                      <ControlLabel>Is Global Team:</ControlLabel>
                      <div>
                        <Toggle
                          onClick={this.onToggleGlobal}
                          on={<span>YES</span>}
                          off={<span>No</span>}
                          size="xs"
                          onstyle="success"
                          offstyle="default"
                          active={isGlobal}
                        />
                      </div>
                      {isGlobal &&
                        <HelpBlock>A global sales team can be maintained by client admins and shared with other client users.</HelpBlock>
                      }
                    </FormGroup>
                  }
                  {canSetupGlobalTeam && isGlobal &&
                    <UserSelector
                      fetchUsers={fetchManagers}
                      users={users}
                      label="Select user(s) who can view this team"
                      onSelect={this.handleSelectUsers}
                      disabled={submitting}
                    />
                  }
                  
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="clearfix">
                  <Button
                    bsStyle="primary"
                    type="submit"
                    className="pull-right"
                    onClick={this.submit}
                    disabled={submitting || invalid}
                  >
                    <Fa name={icon} spin={submitting} /> {btn}
                  </Button>
                  <Button
                    bsStyle="link"
                    className="pull-left"
                    onClick={this.close}
                    disabled={submitting}
                  >
                    Cancel
                  </Button>
                </div>
              </Modal.Footer>
            </form>
          }
        </Modal>
      </div>
    );
  }
}

const selector = formValueSelector('teamForm'); // <-- same as form name
// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    isDefault: selector(state, 'is_default'),
    isGlobal: selector(state, 'is_global'),
    organization: getUserCurrentOrganization(state),
    canSetupGlobalTeam: getCanSetupOrganization(state),
  };
}

TeamModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  initialize: PropTypes.func,
  team: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  show: PropTypes.bool,
  onClose: PropTypes.func,
  invalid: PropTypes.bool,
  change: PropTypes.func,
  submitting: PropTypes.bool,
  isDefault: PropTypes.bool,
  isGlobal:  PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  showSalesGoal: PropTypes.bool,
  canSetupGlobalTeam: PropTypes.bool,
  organization: PropTypes.shape({}).isRequired,
};

TeamModal.defaultProps = {
  team: null,
  show: false,
  initialize: () => {},
  change: () => {},
  onClose: () => {},
  onSuccess: () => {},
  submitting: false,
  isDefault: false,
  invalid: false,
  isGlobal: false,
  canSetupGlobalTeam: false,
  showSalesGoal: false,
};

const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   name: {
  //     presence: true,
  //     length: {
  //       minimum: 1,
  //       maximum: 1024,
  //     },
  //   },
  //   description: {
  //     length: {
  //       maximum: 2048,
  //     },
  //   },
  //   annual_sales_goal: {
  //     numericality: {
  //       greaterThan: 0,
  //     },
  //   },
  // };

  const schema = Joi.object({
    name: Joi.string().min(1).max(1024).required().messages({
      'string.base': 'Name must be a string',
      'string.empty': 'Name is required',
      'any.required': 'Name is required',
      'string.min': 'Name must be at least 1 character',
      'string.max': 'Name must be at most 1024 characters',
    }),
    description: Joi.string().max(2048).allow('', null).messages({
      'string.base': 'Description must be a string',
      'string.max': 'Description must be at most 2048 characters',
    }),
    annual_sales_goal: Joi.number().greater(0).allow(null).messages({
      'number.base': 'Annual sales goal must be a number',
      'number.greater': 'Annual sales goal must be greater than 0',
    }),
  }).unknown(true);

  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};


const TeamForm = reduxForm({
  form: 'teamForm',
  validate,
})(TeamModal);

export default connect(mapStateToProps)(TeamForm);
